<template>
  <div class="d-flex flex-stack flex-wrap mb-10" v-if="pagination">
    <div class="fs-6 fw-bold text-gray-700">
      Mostrando
      {{ pagination.limit * pagination.page - pagination.limit + 1 }} a
      {{ pagination.page * pagination.limit }} de
      {{ pagination.totalDocs }} sites
    </div>

    <ul class="pagination">
      <li class="page-item previous">
        <button
          class="page-link"
          @click="previousPage"
          :disabled="!pagination.hasPrevPage"
        >
          <i class="previous"></i>
        </button>
      </li>

      <template v-if="pagination.totalPages">
        <template v-for="page in partialPages" :key="page">
          <li
            class="page-item"
            :class="{ active: isActive(page) }"
            v-if="pageActive(page)"
          >
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>
        </template>
      </template>

      <li class="page-item next">
        <button
          class="page-link"
          @click="nextPage"
          :disabled="!pagination.hasNextPage"
        >
          <i class="next"></i>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CP-Pagination",

  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },

  emits: ["changePage"],

  computed: {
    partialPages() {
      let pages = [...Array(this.pagination.totalPages).keys()];

      pages.shift();
      pages.push(pages.length + 1);

      return pages;
    },

    start() {
      if (this.pagination.page >= this.pagination.totalPages - 2)
        return this.pagination.totalPages - 4;

      return this.pagination.page - 2;
    },

    end() {
      if (this.pagination.page <= 2) return 5;

      return this.pagination.page + 2;
    },
  },

  methods: {
    isActive(page) {
      return page === this.pagination.page;
    },

    pageActive(page) {
      return page >= this.start && page <= this.end;
    },

    changePage(page) {
      this.$emit("changePage", { page });
    },

    previousPage() {
      this.$emit("changePage", { page: this.pagination.prevPage });
    },

    nextPage() {
      this.$emit("changePage", { page: this.pagination.nextPage });
    },
  },
};
</script>

<style></style>
